"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyRSASignature = exports.signRSAMessage = exports.addressFromPemKey = exports.exportPubKey = exports.pemToKey = void 0;
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const NodeRSA = require("node-rsa");
const constants_1 = require("../constants");
const hex_1 = require("./hex");
const pemToKey = (privateKeyPem) => {
    const key = new NodeRSA(privateKeyPem);
    key.setOptions({ signingScheme: 'pkcs1-sha256' });
    return key;
};
exports.pemToKey = pemToKey;
const exportPubKey = (key) => {
    const pubkey = key.exportKey('components-public');
    if (typeof pubkey.e !== 'number') {
        throw Error('RSA public key e error');
    }
    const pubKeyE = pubkey.e;
    const e = pubKeyE.toString(16).padStart(8, '0');
    const n = pubkey.n.slice(1);
    const eBuffer = Buffer.from(e, 'hex').reverse();
    const nBuffer = n.reverse();
    const pubKey = Buffer.concat([eBuffer, nBuffer]);
    return pubKey.toString('hex');
};
exports.exportPubKey = exportPubKey;
const addressFromPemKey = (privateKeyPem, isMainnet = false) => {
    const pubkey = (0, hex_1.append0x)((0, exports.exportPubKey)((0, exports.pemToKey)(privateKeyPem)));
    const lock = Object.assign(Object.assign({}, (0, constants_1.getJoyIDLockScript)(isMainnet)), { args: `0x0003${(0, ckb_sdk_utils_1.blake160)((0, ckb_sdk_utils_1.hexToBytes)(pubkey), 'hex')}` });
    return (0, ckb_sdk_utils_1.scriptToAddress)(lock, isMainnet);
};
exports.addressFromPemKey = addressFromPemKey;
const signRSAMessage = (key, message) => {
    if (!message.startsWith('0x')) {
        throw new Error('Message format error');
    }
    const signature = key.sign(Buffer.from(message.replace('0x', ''), 'hex'), 'hex');
    (0, exports.verifyRSASignature)(key, message, signature);
    return signature;
};
exports.signRSAMessage = signRSAMessage;
const verifyRSASignature = (key, message, signature) => {
    if (!message.startsWith('0x')) {
        throw new Error('Message format error');
    }
    const result = key.verify(Buffer.from(message.replace('0x', ''), 'hex'), Buffer.from(signature.replace('0x', ''), 'hex'));
    console.log('RSA validate signature: ', result);
    return result;
};
exports.verifyRSASignature = verifyRSASignature;
